import React, { FC } from 'react';
import { Control, UseFormWatch } from 'react-hook-form';
import { ReportConfigDto, ReportType } from '@thingslog/repositories';
import ConsumptionReportSettingsForm from './ConsumptionReportSettingsForm';
import CustomerBillingReportSettingsForm from './CustomerBillingReportSettingsForm';
import AlarmReportSettingsForm from './AlarmReportSettingsForm';
import TransmissionReportSettingsForm from './TransmissionReportSettingsForm';
import LicenseReportSettingsForm from './LicenseReportSettingsForm';

interface ReportSettingsFormFactoryProps {
  reportType: ReportType;
  control: Control<ReportConfigDto>;
  watch: UseFormWatch<ReportConfigDto>;
}

const ReportSettingsFormFactory: FC<ReportSettingsFormFactoryProps> = ({
  reportType,
  control,
  watch,
}: ReportSettingsFormFactoryProps): React.ReactElement | null => {
  switch (reportType) {
    case ReportType.CONSUMPTION_REPORT:
      return <ConsumptionReportSettingsForm control={control} watch={watch} />;
    case ReportType.CONSUMPTION_EXPORT_REPORT:
      return <ConsumptionReportSettingsForm control={control} watch={watch} />;
    case ReportType.CUSTOMER_BILLING_REPORT:
      return <CustomerBillingReportSettingsForm control={control} watch={watch} />;
    case ReportType.ALARM_REPORT:
      return <AlarmReportSettingsForm control={control} watch={watch} />;
    case ReportType.TRANSMISSION_REPORT:
      return <TransmissionReportSettingsForm control={control} watch={watch} />;
    case ReportType.LICENSE_REPORT:
      return <LicenseReportSettingsForm control={control} watch={watch} />;
    default:
      return null;
  }
};

export default ReportSettingsFormFactory;
